configureStore = require './configure_store'
initialState = require './initial_state'

module.exports = configureStore initialState
